import "../../../../chunks/async.js";
import { a as attr } from "../../../../chunks/renderer.js";
import { r as resolve } from "../../../../chunks/server2.js";
function _page($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    $$renderer2.push(`<div class="flex flex-col items-center justify-center py-24 gap-4"><h1 class="text-xl font-semibold">You've been logged out</h1> <p class="text-sm text-[var(--text-muted)]">Your session has been ended.</p> <a${attr("href", resolve("/auth/login"))} class="btn btn-default btn-sm mt-2">Log back in</a></div>`);
  });
}
export {
  _page as default
};
